import SddSection from 'components/OrderConfirmation/SddSections/SddSection/SddSection';
import { withSddSectionProps } from 'viewModel/orderConfirmation/sddSections/sddSection/withSddSectionProps';

const ConnectedSddSection = withSddSectionProps(SddSection);

export default ConnectedSddSection;
